import concaveman from 'concaveman';
import { BufferGeometry, Vector2Tuple, Vector3 } from 'three';

export class Outline2D {
  array: Vector2Tuple[] = [];

  setFromGeometry(geometry: BufferGeometry): this {
    const vertices: Vector2Tuple[] = [];
    const positionAttribute = geometry.getAttribute('position');
    const vertex = new Vector3();
    for (let i = 0; i < positionAttribute.count; i++) {
      vertex.fromBufferAttribute(positionAttribute, i);
      vertices.push([vertex.x, vertex.z]);
    }

    return this.setFromPoints(vertices);
  }

  setFromPoints(points: Vector2Tuple[]) {
    this.array = concaveman(points, Infinity, 1) as Vector2Tuple[];
    return this;
  }
}
